import { FC } from 'react'

import TagCommander, { TcProps } from '../../components/TagCommander'
import { SeoProps } from '../../components/Seo'
import RecipeStepsSection, {
  RecipeStepsSectionProps,
} from '../../components/RecipeStepsSection'
import CoverSection, { CoverSectionProps } from '../../components/CoverSection'
import RecipeIntroductionSection, {
  RecipeIntroductionSectionProps,
} from '../../components/RecipeIntroductionSection'
import RecipeIngredientsSection, {
  RecipeIngredientsSectionProps,
} from '../../components/RecipeIngredientsSection'
import RecipeMenuSection, {
  RecipeMenuSectionProps,
} from '../../components/RecipeMenuSection'
import OthersSection, {
  OthersSectionProps,
} from '../../components/OthersSection'
import Separator from '../../components/Separator'
import RecipeTagsSection, {
  RecipeTagsSectionProps,
} from '../../components/RecipeTagsSection'
import { BreadcrumbProps } from '../../components/Breadcrumb'
import RecipesListSection, {
  RecipesListSectionProps,
} from '../../components/RecipesListSection'

import * as SC from './styled'

export type RecipeTemplateProps = {
  coverSectionProps: CoverSectionProps
  introductionSectionProps: RecipeIntroductionSectionProps
  ingredientsSectionProps: RecipeIngredientsSectionProps
  stepsSectionProps: RecipeStepsSectionProps
  menuSectionProps?: RecipeMenuSectionProps | null
  othersSectionProps: OthersSectionProps
  tagsSectionProps: RecipeTagsSectionProps
  seoProps?: SeoProps
  mobileBreadcrumbProps?: BreadcrumbProps
  tcProps?: TcProps
  isParentRecipe?: boolean
  childrenRecipesListSectionProps?: RecipesListSectionProps
}

const RecipeTemplate: FC<RecipeTemplateProps> = ({
  coverSectionProps,
  introductionSectionProps,
  ingredientsSectionProps,
  stepsSectionProps,
  menuSectionProps,
  othersSectionProps,
  tagsSectionProps,
  mobileBreadcrumbProps,
  tcProps,
  isParentRecipe,
  childrenRecipesListSectionProps,
}) => {
  return (
    <SC.TemplateWrapper>
      <SC.Main>
        {tcProps && <TagCommander {...tcProps} />}
        <CoverSection {...coverSectionProps} />
        {isParentRecipe && childrenRecipesListSectionProps ? (
          <RecipesListSection {...childrenRecipesListSectionProps} />
        ) : (
          <>
            <RecipeIntroductionSection {...introductionSectionProps} />
            <RecipeIngredientsSection {...ingredientsSectionProps} />
            <RecipeStepsSection {...stepsSectionProps} />
            {menuSectionProps?.items.length ? (
              <RecipeMenuSection {...menuSectionProps} />
            ) : null}
          </>
        )}
      </SC.Main>
      <SC.Secondary>
        <RecipeTagsSection {...tagsSectionProps} />
        <Separator />
        <OthersSection {...othersSectionProps} />
      </SC.Secondary>
      {mobileBreadcrumbProps && (
        <SC.MobileBreadcrumb {...mobileBreadcrumbProps} />
      )}
    </SC.TemplateWrapper>
  )
}

export default RecipeTemplate
